import BulletPoint from "@components/BulletPoint"
import { getOnboardingContext, isHomeFlow } from "@helpers/localStorage"
import { useTranslation } from "react-i18next"

const OPTIONS = [
  "bestLook",
  "aiPhoto",
  "transformYourPhotos",
  "perfectPhotos",
] as const

export default function Features() {
  const { t } = useTranslation()
  const context = getOnboardingContext()
  const plansCopyKey =
    context === "cars"
      ? "pages.checkout.plansCars"
      : context === "pets"
        ? "pages.checkout.plansPets"
        : isHomeFlow()
          ? "pages.checkout.plansHome"
          : "pages.checkout.plans"

  return (
    <div className="space-y-8">
      {OPTIONS.map((key) => (
        <BulletPoint
          key={key}
          text={t(`${plansCopyKey}.bulletPoints1.${key}Text`)}
          title={t(`${plansCopyKey}.bulletPoints1.${key}Title`)}
        />
      ))}
    </div>
  )
}
